import { apiClient } from './apiClient';

export interface Activity { id: string; text: string; timeText?: string; createdAt: string }

export async function listActivities(skip = 0, take = 20) {
  const qs = new URLSearchParams({ skip: String(skip), take: String(take) }).toString();
  return apiClient.get<{ items: Activity[] }>(`/activities?${qs}`);
}

export async function createActivity(text: string, timeText?: string) {
  return apiClient.post<Activity>(`/activities`, { text, timeText });
}

export async function deleteActivity(id: string) {
  return apiClient.delete(`/activities/${id}`);
}
